import { useEffect, useState } from "react";
import Dropdown from "components/Dropdown";
import trucksService from "services/trucks.service";

const SearchSelection = ({
  location,
  setLocation,
  selected,
  setSelected,
  className,
  icon,
}) => {
  const [list, setList] = useState([]);

  const handleClick = (e) => {
    const { city, state, zip } = e.value || {};
    setSelected({ ...selected, location: { city, state, zip } });
  };

  useEffect(() => {
    const locationValue = location.location.title;

    if (locationValue.length > 3 && locationValue !== "") {
      trucksService.getLocationsList({ location: locationValue }).then(
        ({ data }) => {
          const dropdownList = data?.map(({ city, state, zip_code }) => {
            return {
              title: `${city}, ${state} ${zip_code ? zip_code : ""}`,
              value: { city, state, zip: zip_code },
            };
          });
          setList(dropdownList);
        },
        ({ response }) => {
          console.error(response);
        },
      );
    } else {
      setList([]);
      setSelected({ ...selected, location: { city: "", state: "", zip: "" } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <>
      <Dropdown
        list={list}
        withInput={true}
        value={location}
        setValue={setLocation}
        className={className}
        label="Location"
        keyValue="location"
        handleClick={handleClick}
        icon={icon}
      />
    </>
  );
};

export default SearchSelection;
